export default __webpack_public_path__ + "static/media/AmClub.fed9d75b.jpg";